import { render, staticRenderFns } from "./StdRiskTxtForm.vue?vue&type=template&id=1d98d914&"
import script from "./StdRiskTxtForm.vue?vue&type=script&lang=js&"
export * from "./StdRiskTxtForm.vue?vue&type=script&lang=js&"
import style0 from "./StdRiskTxtForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "StdRiskTxtForm.vue"
export default component.exports